import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { SelectionTable } from '@ui/tables';
import { ValidationRuleRow } from './ValidationRuleRow';
import { ValidationRuleSearch } from './ValidationRuleSearch';
import { getRowKey, paginationDefaultQueryParams, paginationFallbackQueryParams, PeriscopePagination } from '../';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useRef } from 'react';
import { useQueryResource, useSelectionTable } from '@hooks';
export const ValidationRuleSearchableSelectionTable = ({ parentIndex, resourceIdsUri, uri }) => {
    const scrollableListRef = useRef(null);
    const { loading, resource, queryParams, updateParams } = useQueryResource({
        defaultParams: Object.assign(Object.assign({}, paginationDefaultQueryParams), { hideInactive: true }),
        fallbackParams: paginationFallbackQueryParams,
        uri
    });
    const selectionData = useSelectionTable({
        getRowKey,
        queryParams,
        resourceIdsUri: resourceIdsUri,
        results: resource === null || resource === void 0 ? void 0 : resource.results,
        selectionType: SonarObjectType.SalesforceValidationRule
    });
    const renderValidationRule = useCallback((rule) => React.createElement(ValidationRuleRow, { key: rule.sonarObjectId, parentIndex: parentIndex, rule: rule }), [parentIndex]);
    const results = resource === null || resource === void 0 ? void 0 : resource.results;
    return (React.createElement(React.Fragment, null,
        React.createElement(ValidationRuleSearch, { onChange: updateParams, queryParams: queryParams }),
        React.createElement(SelectionTable, { dataSource: results, forceShowSelection: resourceIdsUri ? undefined : false, loading: loading, ref: scrollableListRef, renderRow: renderValidationRule, rowKey: getRowKey, selectionData: selectionData, selectionType: PERISCOPE_TAB_TYPES.VALIDATION_RULES }),
        React.createElement(PeriscopePagination, { loading: loading, onChange: updateParams, queryParams: queryParams, scrollRef: scrollableListRef, totalCount: Number(resource === null || resource === void 0 ? void 0 : resource.totalCount) })));
};
